/* eslint-disable no-underscore-dangle */
import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import reduxReset from 'redux-reset'
import * as reducers from './reducers';

// TODO: maybe we should add this to the project for dev-only, 
// as it will keep us out of troubles
// import reduxImmutableStateInvariant from 'redux-immutable-state-invariant';

const combinedReducers = combineReducers(reducers);

const middlewares = [thunk, createLogger()];

export default function configureStore(initialState) {
  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
  return createStore(
    combinedReducers,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares), reduxReset())
  );
}



// WEBPACK FOOTER //
// ./src/redux/configureStore.js